import React, { useEffect, useState } from "react";
import { Button, Form, Grid, Icon, Modal, Popup } from "semantic-ui-react";
import Files from "react-files";
import { uid } from "uid";
import { connect, useDispatch } from "react-redux";
import { compose } from "redux";
import { firestoreConnect } from "react-redux-firebase";
import { newSlideshowphoto } from "../../../store/actions/slideshowActions";
import CropFeature from "./CropFeature";
import Card from "./Card";

const Add = (props) => {
  const [error, setError] = useState(null);
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState(null);
  const [fileURL, setFileURL] = useState(null);
  const [cropFeature, setCropFeature] = useState(false);
  const [cropped, setCropped] = useState(false);
  const dispatch = useDispatch();

  // close function
  const handleClose = () => {
    setError(null);

    setFile(null);
    setFileName(null);
    props.close();
  };
  // Submit Function
  const handleSubmit = () => {
    if (file && fileName && !error) {
      const toFirestore = {
        id: uid(8),
        file,
      };
      toFirestore.fileName = `${toFirestore.id}_${fileName}`;
      dispatch(newSlideshowphoto(toFirestore));
    } else setError("All fields are required");
  };
  // Automatically Closes After Adding to Database
  useEffect(() => {
    if (props.newStwAdd) {
      handleClose();
    }
  }, [props.newStwAdd]);

  // Automatically Clears Error if all data are there
  useEffect(() => {
    if (fileName && file && error) {
      setError(null);
    }
  }, [fileName, file, error]);

  return (
    <Modal
      size="small"
      className="cu-event-modal"
      onClose={handleClose}
      open={props.open}
    >
      <Modal.Content scrolling>
        <div className="AdminTopButtonsProgressContainer">
          <div className="AdminTopButtonsContainer">
            <Button
              floated="left"
              circular
              icon="close"
              onClick={handleClose}
            />
            {!cropped ? (
              <Popup
                content={error ? error : "Cropped Image Only"}
                trigger={
                  <Button
                    disabled={error}
                    floated="right"
                    negative
                    name="saveButton"
                    content="Save"
                    labelPosition="right"
                    icon="checkmark"
                  />
                }
              />
            ) : (
              <Button
                disabled={error}
                loading={props.newStwAdding}
                floated="right"
                positive
                name="saveButton"
                content="Save"
                labelPosition="right"
                icon="checkmark"
                onClick={handleSubmit}
              />
            )}
          </div>
          {error && <p style={{ color: "#800000" }}>{error}</p>}
          {props.newStwError && (
            <p style={{ color: "#800000" }}>{props.newStwError.message}</p>
          )}
        </div>
        <Form>
          <div className="AdminFormEventContainer add-partner-modal">
            <h3>Add Photo</h3>
            <Grid divided="vertically">
              {file && (
                <Grid.Row stackable="true" columns={1}>
                  <Grid.Column mobile={16} tablet={16} computer={16}>
                    <div className="about-slide-show text-center">
                      <Card image={{ fileURL }} superAdminPreview />
                    </div>

                    {fileName && <p className="note cu-center">{fileName}</p>}
                  </Grid.Column>
                </Grid.Row>
              )}
              <Grid.Row stackable="true">
                <Grid.Column mobile={16} tablet={16} computer={16}>
                  <Files
                    className="files-dropzone"
                    accepts={["image/*", ".heic"]}
                    clickable
                    multiple={false}
                    onChange={(file) => {
                      setCropped(false);
                      setFile(file[0]);
                      setFileName(file[0].name);
                      setError(null);
                      setFileURL(file[0].preview.url);
                      setCropFeature(true);
                    }}
                  >
                    <label className="btn-cu ui green button btn-cu w-100">
                      <Icon name="upload" />
                      Upload Image
                    </label>
                  </Files>
                  {file && (
                    <CropFeature
                      imgSrc={file}
                      getCroppedImage={(croppedImage) => {
                        setCropped(true);
                        setFile(croppedImage);
                        setFileURL(URL.createObjectURL(croppedImage));
                      }}
                      open={cropFeature}
                      close={() => setCropFeature(false)}
                      abort={() => {
                        setFile(null);
                        setFileName(null);
                        setError("Image Is Required");
                        setFileURL(null);
                        setCropFeature(false);
                      }}
                    />
                  )}
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </div>
        </Form>
      </Modal.Content>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
    newStwAdd: state.slideshowPhoto.Add,
    newStwError: state.slideshowPhoto.AddError,
    newStwAdding: state.slideshowPhoto.Adding,
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect(() => {
    const firestoreArray = [
      {
        collection: "partners",
      },
    ];
    return firestoreArray;
  })
)(Add);
